import styles from "../css/styles.module.css";

const Card_Component = (label, text) => {
  return (
    <div className=" col-lg-3 col-md-6 col-lg-4 ">
      <div className={`card border-primary ${styles.height_160} `}>
        <div className="card-body px-4 py-4-2 center">
          <div className={`row `}>
            <h5
              className={`font-semibold text-center text-muted ${styles.homePage_h5} `}
            >
              {" "}
              <span>
                <b>{label}</b>
              </span>{" "}
              {text}
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card_Component